import analytics from '@/Analytics';
import { toPascalCase } from '@/Utils/StringUtility.js';
import { analyticsPluginName } from '@/Utils/AnalyticsUtility';

const overlayTrackingProviderNames = [analyticsPluginName.clarity];

function normalizeComponentTrackingName(value) {
    const normalizedValue = value.split('.').pop();
    return toPascalCase(normalizedValue);
}

function resolveComponentName(componentInstance) {
    const componentOptions = componentInstance?.$options || {};
    return componentOptions.name || componentOptions._componentTag;
}

function resolveParentComponentName(componentInstance) {
    // We need to check grandparent as well, because parent might be a generic like Transition
    const parent = componentInstance?.$parent;
    const grandparent = parent?.$parent;

    return resolveComponentName(parent) || resolveComponentName(grandparent);
}

function resolveOverlayTrackingName(componentInstance) {
    return normalizeComponentTrackingName(resolveParentComponentName(componentInstance));
}

export function trackOverlayEvent({ componentInstance, overlayType, action, componentName, title }) {
    const eventName = `${overlayType}_${action}`;
    const payload = {
        component_name: componentName || resolveOverlayTrackingName(componentInstance),
    };

    if (title) {
        payload[`${overlayType}_title`] = title;
    }

    analytics.trackTo(overlayTrackingProviderNames, eventName, payload);
}